import request from '@/plugin/axios'
export function getRole(id) {
    return request({
        url: '/role/' + id,
        method: 'get',
        loading: {
            type: 'nprogress',
            interval: 500
        }
    })
}
export function getRolePagedList(query) {
    return request({
        url: '/moblieapp/rolePagedlist',
        method: 'post',
        params: query,
        loading: {
            type: 'nprogress',
            interval: 500
        }
    })
}
export function delRole(id) {
    return request({
        url: '/moblieapp/roleDel',
        method: 'post',
        params: { id: id },
        success: {
            type: 'message',
            options: {
                message: '删除成功',
                type: 'success'
            }
        }
    })
}
export function delRoles(ids) {
    return request({
        url: '/moblieapp/batchdel',
        method: 'post',
        params: ids,
        success: {
            type: 'message',
            options: {
                message: '删除成功',
                type: 'success'
            }
        }
    })
}
export function saveRole(data) {
    return request({
        url: '/moblieapp/roleSave',
        method: 'post',
        data: data,
        success: {
            type: 'message',
            options: {
                message: '保存成功',
                type: 'success'
            }
        }
    })
}
export function getRolePermissions(data) {
    return request({
        url: '/moblieapp/roleGetpermissions' ,
        method: 'post',
        data: data,
        loading: {
            type: 'loading',
            options: {
                fullscreen: true,
                lock: true,
                text: '加载中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.8)'
            }
        }
    })
}
export function savePermission(data) {
    return request({
        url: '/moblieapp/roleSavepermission',
        method: 'post',
        data: data,
        success: {
            type: 'message',
            options: {
                message: '保存成功',
                type: 'success'
            }
        }
    })
}